export enum CampaignStepsEnum {
    General = 'general',
    Segment = 'segment',
    Award = 'award',
    Template = 'template',
    Schedule = 'schedule',
    ABTest = 'abTest',
    Overview = 'overview',
}

export enum CommunicationTypeEnum {
    Unknown = 0,
    Email = 1,
    SMS = 2,
    PushNotification = 3,
    PopUpNotification = 4,
    InternalMessage = 5,
    Telegram = 6,
    Bonus = 7,
    CMSPopUpNotification = 8,
    Viber = 9,
    Hoory = 10,
    DynamicPopUp = 12,
    WhatsApp = 14,
    CMSBanner = 15,
    WhatsAppProvider = 16,
}

export enum CommunicationReasonEnum {
    None = 0,
    // Reasons for Skipped status
    PartOfOtherPromo = 1,
    PartOfExclusiveABTest = 2,
    PartOfControlGroup = 3,
    ClientExcluded = 4,
    AwardNotSent = 5,
    Unsubscribed = 6,
    BestChannelNotSet = 7,
    BestChannelNotDefined = 8,
    AwardNotAllowed = 9,
    ClientBanned = 10,
    NonCustomerIsClient = 12,
    ClientInExclusionRule = 13,
    // Reasons for Failed status
    InternalError = 20,
    ExternalError = 21,
    InvalidContact = 11,
    BanServiceError = 23,
    PromoLimit = 24,
    // Reason for Success status
    PartOfTargetGroup = 40,
}

export enum CommunicationReasonLabelEnum {
    None = 'CommunicationReasonNone',
    // Reasons for Skipped status
    PartOfOtherPromo = 'CommunicationReasonPartOfOtherPromo',
    PartOfExclusiveABTest = 'CommunicationReasonPartOfExclusiveABTest',
    PartOfControlGroup = 'CommunicationReasonPartOfControlGroup',
    ClientExcluded = 'CommunicationReasonClientExcluded',
    AwardNotSent = 'CommunicationReasonAwardNotSent',
    Unsubscribed = 'CommunicationReasonUnsubscribed',
    BestChannelNotSet = 'CommunicationReasonBestChannelNotSet',
    BestChannelNotDefined = 'CommunicationReasonBestChannelNotDefined',
    AwardNotAllowed = 'CommunicationReasonAwardNotAllowed',
    ClientBanned = 'CommunicationReasonClientBanned',
    NonCustomerIsClient = 'CommunicationReasonNonCustomerIsClient',
    ClientInExclusionRule = 'CommunicationReasonClientInExclusionRule',
    // Reasons for Failed status
    InternalError = 'CommunicationReasonInternalError',
    ExternalError = 'CommunicationReasonExternalError',
    InvalidContact = 'CommunicationReasonInvalidContact',
    BanServiceError = 'CommunicationReasonBanServiceError',
    PromoLimit = 'CommunicationReasonPromoLimit',
    // Reason for Success status
    PartOfTargetGroup = 'CommunicationReasonPartOfTargetGroup',
}

export enum CommunicationStatusEnum {
    Succeeded = 0,
    Failed = 1,
    Pending = 2,
    Queued = 3,
    Skipped = 4,
}

export enum CampaignExecutionStatusEnum {
    Success = 0,
    Sending = 1,
    Fail = 2,
    Stop = 3,
    PreparingSegment = 4,
}

export enum PreCalculationTypeEnum {
    Hours = 'hours',
    Immediately = 'immediately',
}

export enum PreCalculationFormFieldsEnum {
    IsActive = 'isActive',
    Hours = 'hours',
    Type = 'type',
}
